import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import _isFunction from "lodash/isFunction";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.concat.js";
import { useState, useEffect, useImperativeHandle } from 'react';
import validateInput from '../inputValidation';
var delimiter = '-';
export var usePhoneInput = function usePhoneInput(_ref, countryListOptions) {
  var _countryListOptions$f, _countryListOptions$f2, _initValue$split$;

  var initValue = _ref.value,
      required = _ref.required,
      validate = _ref.validate,
      isTouchedInit = _ref.isTouched,
      componentRef = _ref.componentRef,
      onError = _ref.onError,
      onChange = _ref.onChange;
  var dropdownInitValue = (_countryListOptions$f = (_countryListOptions$f2 = countryListOptions.find(function (el) {
    return (el === null || el === void 0 ? void 0 : el.phone) === (initValue === null || initValue === void 0 ? void 0 : initValue.split(delimiter)[0]);
  })) === null || _countryListOptions$f2 === void 0 ? void 0 : _countryListOptions$f2.phone) !== null && _countryListOptions$f !== void 0 ? _countryListOptions$f : null;
  var inputInitValue = (initValue === null || initValue === void 0 ? void 0 : initValue.indexOf(delimiter)) === -1 ? initValue : (_initValue$split$ = initValue === null || initValue === void 0 ? void 0 : initValue.split(delimiter)[1]) !== null && _initValue$split$ !== void 0 ? _initValue$split$ : '';

  var _useState = useState(inputInitValue !== null && inputInitValue !== void 0 ? inputInitValue : ''),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = useState(dropdownInitValue),
      _useState4 = _slicedToArray(_useState3, 2),
      dropdownValue = _useState4[0],
      setDropdown = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var _useState7 = useState(isTouchedInit),
      _useState8 = _slicedToArray(_useState7, 2),
      isTouched = _useState8[0],
      setIsTouched = _useState8[1];

  useEffect(function () {
    (dropdownInitValue === null || dropdownInitValue === void 0 ? void 0 : dropdownInitValue.phone) !== dropdownValue && setDropdown(dropdownInitValue);
    setInputValue(inputInitValue);
  }, [dropdownInitValue, inputInitValue]);
  useEffect(function () {
    isTouched && checkForError(dropdownValue, inputValue);
  }, [isTouched]);
  useEffect(function () {
    setIsTouched(isTouchedInit);
  }, [isTouchedInit]);
  useImperativeHandle(componentRef, function () {
    return {
      checkForError: checkForError,
      setError: handleError,
      inputValue: inputValue,
      dropdownValue: dropdownValue,
      value: "".concat(dropdownValue).concat(delimiter).concat(inputValue),
      changeIsTouched: setIsTouched,
      reset: handleReset
    };
  });

  var handleBlur = function handleBlur() {
    return !isTouched ? setIsTouched(true) : checkForError(dropdownValue, inputValue);
  };

  var handleError = function handleError(newError) {
    isTouched && setError(newError);
    _isFunction(onError) && onError(newError);
  };

  var handleReset = function handleReset() {
    setInputValue(inputInitValue);
    setDropdown(dropdownInitValue);
  };

  var handleInputChange = function handleInputChange(val) {
    setInputValue(val);
    checkForError(dropdownValue, val);
    _isFunction(onChange) && dropdownValue && onChange("".concat(dropdownValue).concat(delimiter).concat(val));
  };

  var handleDropdownChange = function handleDropdownChange(val) {
    setDropdown(val);
    checkForError(val, inputValue);
    _isFunction(onChange) && val && (inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) && onChange("".concat(val).concat(delimiter).concat(inputValue));
  };

  var checkForError = function checkForError(dropdownValue, inputValue) {
    var newError = null;
    if (_isFunction(validate) && !newError) newError = validate({
      input: inputValue,
      phone: dropdownValue
    });else if (required) newError = validateInput('required')(inputValue) || validateInput('required')(dropdownValue);
    handleError(newError);
  };

  return {
    inputValue: inputValue,
    dropdownValue: dropdownValue,
    handleBlur: handleBlur,
    handleInputChange: handleInputChange,
    handleDropdownChange: handleDropdownChange,
    error: error,
    isTouched: isTouched
  };
};